import React, { useState } from 'react';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import LineIcon from '@mui/icons-material/TableRows';
import {
  Avatar,
  IconButton,
  ListItem,
  ListItemAvatar,
  ListItemButton,
  ListItemText,
  Menu,
  MenuItem,
} from '@mui/material';
import { Link, useNavigate } from 'react-router';

import { getAnchorProps, MenuAnchor } from '@paragon/client-tools';
import { Line } from '@paragon/contract-library';

import { unInsertStation } from '../../../actions/supervisorActions';
import { renderBreadcrumbsToString, useLineBreadcrumbs } from '../../../selectors/breadcrumbsSelector';
import { useAppDispatch } from '../../hooks';

interface LineListItemProps {
  line: Line;
  stationGuid: string;
  isSupervisor: boolean;
}

export function LineListItem(props: LineListItemProps) {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [menuAnchor, setMenuAnchor] = useState<MenuAnchor>(null);

  const breadcrumbs = useLineBreadcrumbs(props.line.guid);

  const lineUrl = `/lines/${props.line.guid}`;

  return (
    <ListItem
      disablePadding
      secondaryAction={
        props.isSupervisor ? (
          <IconButton
            onClick={(event) => {
              event.preventDefault();
              setMenuAnchor({ current: event.currentTarget });
            }}
          >
            <MoreVertIcon />
          </IconButton>
        ) : undefined
      }
      onContextMenu={
        props.isSupervisor
          ? (event) => {
              event.preventDefault();
              setMenuAnchor({ x: event.clientX, y: event.clientY });
            }
          : undefined
      }
    >
      {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
      {/* @ts-ignore */}
      <ListItemButton LinkComponent={Link} to={lineUrl}>
        <ListItemAvatar>
          <Avatar>
            <LineIcon />
          </Avatar>
        </ListItemAvatar>
        <ListItemText
          primary={props.line.name}
          secondary={renderBreadcrumbsToString(breadcrumbs, { omitSelf: true })}
        />
      </ListItemButton>

      <Menu open={menuAnchor != null} {...getAnchorProps(menuAnchor)} onClose={() => setMenuAnchor(null)}>
        <MenuItem onClick={() => void navigate(lineUrl)}>View line</MenuItem>
        <MenuItem
          onClick={() => {
            setMenuAnchor(null);
            dispatch(unInsertStation(props.stationGuid, props.line.guid));
          }}
        >
          Remove from this line
        </MenuItem>
      </Menu>
    </ListItem>
  );
}
